import styled from 'styled-components';

import { theme } from '../../../global';

export const FooterContainer = styled.div`
  background:
    linear-gradient(
      0deg,
      ${theme.colors.lightPurpleOpacity},
      ${theme.colors.lightPurpleOpacity}
    ),
    linear-gradient(0deg, ${theme.colors.white}, ${theme.colors.white});
  display: flex;
  align-items: flex-start;
  justify-content: center;
  border-top: 1px solid ${theme.colors.line};
  margin-top: auto;
  width: 100%;
  height: 104px;
  gap: ${theme.spacings.s40};
  padding: ${theme.spacings.s32} ${theme.spacings.s64};

  @media (max-width: 1358px) {
    height: 196px;
    flex-direction: column;
    padding: ${theme.spacings.s24} ${theme.spacings.s16};
    gap: ${theme.spacings.s24};
  }
`;

export const FooterLogo = styled.div`
  display: flex;
  gap: ${theme.spacings.s16};

  svg {
    width: 35px;
    height: 24px;
  }

  span {
    font-family: 'Montserrat';
    font-weight: 500;
    font-size: 14px;
    white-space: nowrap;
  }
`;

export const FooterText = styled.span`
  font-family: 'Montserrat';
  font-weight: 400;
  font-size: 14px;
  color: ${theme.colors.secondaryText};
`;
